import { useEffect, useState } from "react"
import { SettingsGroup } from "../../../Modules/General"
import * as Basic from "../../../Modules/BasicFields"

export default function HypeOMeter( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const requiredData = [
    ]

    const cfgName = "pulse_hype_o_meter_cfg"

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}
    }

    useEffect( () => {
        reload()
    },[])

    /*useEffect( () => {

        if( requiredData.includes(null) )
        {
            return
        }
        
        let data = {}

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ memory ])*/

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <> 
        </>
    )
}
